import { FilterDisplayComponent } from "./filterDisplay";

export const FilterDisplay = FilterDisplayComponent;
